import { numberWithSpaces } from '../../../framework/framework/tools/numberWithSpaces';
import { IProductIndexModel } from './IProductItemModel';
import * as style from './style.css';
import ShopIcon from '../../../assets/icons/ShopIcon';
import { ActionT2 } from '../../../framework/framework/components/Types';
import React = require('react');

interface IProps {
    item: IProductIndexModel;
    buyClick?: ActionT2<number, string>;
}
interface IState { }

export class ProductIndexCard extends React.Component<IProps, IState> {
    render() {
        const item = this.props.item;
        return (
            <a className={style.itemAnchor} href={item.uri}>
                <div className={style.itemWrapper}>
                    <div className={style.item}>
                        <div className={style.image}>
                            {item.discount &&
                                <div className={style.ribbon}>
                                    <div>-{item.discount}%</div>
                                </div>}
                            <img src={item.thumbnail + '/200'}></img>
                        </div>
                        <div className={style.name}>
                            {item.name}

                        </div>
                        <div className={style.footer}>
                            <div className={style.basketIcon} onClick={(e) => this.handleBasketClick(e)} title={'Dodaj do koszyka'}>
                                <ShopIcon />
                            </div>
                            <div className={style.prices}>
                                {this.getPrices(item)}

                            </div>
                        </div>
                    </div>
                </div>
            </a>
        );
    }

    getPrices(item: IProductIndexModel): JSX.Element {
        if (item.promoPrice) {
            return <>
                <div className={style.h3Promo}>
                    <div className={style.label}>
                        Promocja
                    </div>
                    <h3>
                        {numberWithSpaces(item.price)}
                    </h3>
                </div>
                <h2>
                    {numberWithSpaces(item.promoPrice)} zł
                </h2>
            </>;
        }
        return <>
            <h2>
                {numberWithSpaces(item.price)} zł
            </h2>
        </>;
    }

    handleBasketClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        e.preventDefault();
        if (this.props.buyClick) { this.props.buyClick(this.props.item.id, this.props.item.name); }
    }
}
